import React from 'react'
import PropTypes from 'prop-types'
import {Link} from "react-router-dom";

StaticOverviewTableItem.propTypes = {
    item: PropTypes.object
}

function StaticOverviewTableItem(props) {
    const {item} = props
    const {actions} = item

    return (
        <tr className='StaticOverviewTableItem'>
            <td className="Name">
                <Link
                    to={{
                        pathname: "/users-statics-detail",
                        search: `user=${item.user}`
                    }}
                >
                    {item.user}
                </Link>
            </td>
            <td className="StaticCol">{actions.updated_status_printed || ''}</td>
            <td className="StaticCol">{actions.updated_status_cut || ''}</td>
            <td className="StaticCol">{actions.updated_status_engraved || ''}</td>
            <td className="StaticCol">{actions.updated_status_improved || ''}</td>
            <td className="StaticCol">{actions.mark_as_qc || ''}</td>
            {/* FAC-25991: Đóng gói đổi sang key mark_item_packaged. Đọc kèm key cũ để BE/FE deploy thứ tự nào cũng được — bỏ fallback ở đợt sau. */}
            <td className="StaticCol">{actions.mark_item_packaged || actions.scan_barcode_to_package || ''}</td>
            <td className="StaticCol">{actions.updated_status_labelled || ''}</td>
            <td className="StaticCol">{actions.updated_status_packaged || ''}</td>
            <td className="StaticCol">{actions.photo_updated || ''}</td>
            <td className="StaticCol">{actions.mark_qc_error || ''}</td>
        </tr>
    )

}

export default StaticOverviewTableItem
